<template>
<div id="password-strength"><div :class="['strength', strengthInfo.class]"></div></div>
<p id="strength-text">{{ strengthInfo.text }}</p>
</template>

<script>
export default {
    props: {
        password: String,
        modelValue: Number
    },
    methods: {
        checkPasswordStrength() {
            const strength = this.calculatePasswordStrength(this.password);
            this.$emit('update:modelValue', strength)

            switch (strength) {
                case 0:
                    return {
                        class: 'strength',
                        text: ''
                    }
                case 1:
                    return {
                        class: 'weak',
                        text: 'Debil'
                    }
                case 2:
                    return {
                        class: 'fair',
                        text: 'Regular'
                    }
                case 3:
                    return {
                        class: 'good',
                        text: 'Buena'
                    }
                case 4:
                    return {
                        class: 'strong',
                        text: 'Fuerte'
                    }
            }
        },
        calculatePasswordStrength(password) {
            let strength = 0;
            
            // Check for various criteria
            if (password.length >= 8) strength++; // Minimum length
            if (/[A-Z]/.test(password)) strength++; // Contains uppercase letter
            if (/[a-z]/.test(password)) strength++; // Contains lowercase letter
            if (/[0-9]/.test(password)) strength++; // Contains number
            if (/[\W]/.test(password)) strength++; // Contains special character

            // Ensure strength does not exceed 4
            return Math.min(strength, 4);
        }
    },
    computed: {
        strengthInfo () {
            return this.checkPasswordStrength()
        }
    }
}
</script>